
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policy/sellers",
      function () {
        return require("private-next-pages/policy/sellers.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/policy/sellers"])
      });
    }
  